// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAqoIjzfTh9ulUm1JdATu7aUUieHl4gn7g",
  authDomain: "prisu-f1dce.firebaseapp.com",
  projectId: "prisu-f1dce",
  storageBucket: "prisu-f1dce.firebasestorage.app",
  messagingSenderId: "452117486001",
  appId: "1:452117486001:web:a8c38d014f515661ea4590",
  measurementId: "G-0W42YFLH7X"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const storage = getStorage(app);